import { render, staticRenderFns } from "./Demo.vue?vue&type=template&id=685e92a2&"
import script from "./Demo.vue?vue&type=script&lang=js&"
export * from "./Demo.vue?vue&type=script&lang=js&"
import style0 from "./Demo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
